import React from "react";
import { Mail, ArrowRight } from "lucide-react";
import PageShell, { Section } from "@/components/PageShell";

const TAGS = [
  "Fintech",
  "Financial inclusion",
  "Product",
  "Operations",
  "Compliance",
  "Customer support",
  "Engineering",
];

const Careers = () => (
  <PageShell
    eyebrow="// Careers"
    title="Careers at GigAfloat"
    subtitle="We're building the future of financial support for gig workers."
    testid="careers-page"
  >
    <Section>
      <p>
        Although we don't currently have open positions, we're always interested in connecting with talented people who are passionate about fintech, financial inclusion, product development, operations, compliance, customer support, and technology.
      </p>
    </Section>

    <Section title="Where we tend to invest">
      <div className="flex flex-wrap gap-2 pt-1">
        {TAGS.map((t) => (
          <span
            key={t}
            className="px-3 py-1.5 rounded-full text-xs font-semibold border border-white/10 bg-white/[0.02] text-white/75"
            data-testid={`careers-tag-${t.toLowerCase().replace(/\s/g, "-")}`}
          >
            {t}
          </span>
        ))}
      </div>
    </Section>

    <Section title="Interested in future opportunities?">
      <p>
        Send a short note and your background to{" "}
        <a href="mailto:gigafloatapp@gmail.com?subject=Careers%20Inquiry" className="text-[#00FF88]">
          gigafloatapp@gmail.com
        </a>
        . We keep all introductions on file and reach out when something relevant opens up.
      </p>
      <a
        href="mailto:gigafloatapp@gmail.com?subject=Careers%20Inquiry"
        className="mt-3 inline-flex items-center gap-2 bg-[#00FF88] text-black font-bold text-sm px-6 py-3 rounded-full btn-glow"
        data-testid="careers-cta"
      >
        <Mail className="w-4 h-4" />
        Contact us
        <ArrowRight className="w-4 h-4" />
      </a>
    </Section>
  </PageShell>
);

export default Careers;
